import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { DecodeResponse } from "../../Models/Response/Redirection/redirection";
import { setDecryptedCredential } from "../../Services/LocalStorageServices";
import { decode } from "../../Services/RedirectionServices/Redirection";
import { QueryParams, Routes } from "../../Utils/Constants/routes";

const Redirection: React.FC = () => {
  const history = useHistory();
  useEffect(() => {
    const queryParam = new URLSearchParams(history.location.search);

    const fi = queryParam.get("fi")?.replace(/\s/g, "+");
    const reqdate = queryParam.get("reqdate");
    const ecreq = queryParam.get("ecreq");

    console.log("FI: " + fi?.toString());

    if (!!fi && !!reqdate && !!ecreq) {
      decode({ fi, ecreq, reqdate })
        .then((res) => res.data)
        .then((res: DecodeResponse) => {
          setDecryptedCredential(res);
          if (res.isUserPresent) {
            history.push({
              pathname: Routes.login,
              search: `?${QueryParams.redirect}=/consent/PENDING/${res.srcref}`,
              state: { phoneNumber: res.phoneNumber },
            });
          } else {
            history.push({
              pathname: Routes.signup,
              search: `?${QueryParams.redirect}=/consent/PENDING/${res.srcref}`,
              state: { phoneNumber: res.phoneNumber, isVuaIdDisabled: true },
            });
          }
        })
        .catch((res: any) => {
          if (!!res.redirectōUrl) {
            window.location.replace(res.redirectUrl);
          }
        });
    }
  }, [history]);

  return <div>Loading...</div>;
};

export default Redirection;
